import "promise-polyfill/src/polyfill";
import objectFitImages from "object-fit-images";
import lightbox from "./lightbox";
import lightboxGallery from "./lightbox-gallery";
import cartPopup from "./cart-popup";
import cart from "./cart";
import checkoutInfo from "./checkout-info";
import smoothScroll from "./smooth-scroll";
import swiper from "./swiper";
import toggle from "./toggle";
import productApp from "./product-app";
import contact from "./contact";
import header from "./header";
import birthList from "./birth-list";
import products from "./products";
import notifications from "./notifications";
import newsflash from "./newsflash";
import hero from "./hero";
import voucherApp from "./voucher-app";
import "./cookie";

import Vue from "vue";
export const bus = new Vue();

notifications();

objectFitImages(null, { watchMQ: true });
cartPopup();
cart();
checkoutInfo();
smoothScroll();
swiper();
toggle();
productApp();
contact();
header();
// Init lightbox here as swiper has some lightbox classes which need to trigger after swiper is initialised
lightbox();
lightboxGallery();
products();
birthList();
newsflash();
hero();
voucherApp();